import Vue from 'vue'
import Vuex, { GetterTree, MutationTree, ActionTree } from 'vuex'
Vue.use(Vuex)

interface State {
  show: boolean;
  aspect: string;
  videoId: string | null;
}

const getDefaultState = (): State => {
  return {
    show: false,
    aspect: '16:9',
    videoId: null
  }
}
const state = getDefaultState()

const getters: GetterTree<State, any> = {
  show (state: State) {
    return state.show
  }
}

const mutations: MutationTree<State> = {
  OPEN_VIDEO_MODAL (state: State, payload: { url: string; aspect: number[] }) {
    const url = payload.url
    const aspect = payload.aspect ? payload.aspect.join(':') : '16:9'
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
    const match = url.match(regExp)
    const videoId = (match && match[7].length === 11) ? match[7] : false
    if (videoId) {
      state.videoId = videoId
      state.aspect = aspect
      state.show = true
    }
  },
  CLOSE_VIDEO_MODAL (state: State) {
    state.show = false
    state.videoId = null
  }
}

const actions: ActionTree<State, any> = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
